<div class="flex justify-center items-center">
    <img class="bg-emerald-500 w-32 md:w-44 mt-16 md:mt-32 rounded-full" src="assets/corazon.png" alt="">
</div>
<div class="flex justify-center items-center flex-wrap">
    <h2 class="text-4xl mt-4 text-slate-800 dark:text-slate-200">¡Gracias por tu apoyo!</h2>
    <p class="text-2xl mt-7 mx-10 md:mx-44 lg:mx-56 text-center text-slate-800 dark:text-slate-100">
        Te agradecemos infinitamente por creer en el proyecto, gracias a ti continuaremos desarrollando 
        y ofreciendo el servicio de forma gratuita y sin anuncios. 
    </p>
    <p class=" my-14 text-2xl bg-slate-800 dark:text-slate-400">Con 💜 del equipo de ReliefApp</p>
</div>
<div class=" absolute bottom-0 right-6">
    <a href="/landing"><img class="w-44 md:w-64 lg:w-80" src="assets/draw.png"  /></a>
</div>